import React, { useState,useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "../../styles/Login.css";
import loginImg from "../../assets/loginImage.jpeg";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import logo from "../../assets/Logo.png";
import { EMAIL_REGEX } from "../../constants/common";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false); // State for loading
  const [showPassword, setShowPassword] = useState(false); // State for showing password
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email.trim() === "" || password.trim() === "") {
      setSubmitted(true); // Set submitted to true when form is submitted
      return;
    }

    // Email validation
    // const emailRegex =
    //   /^[^\s@]+@[^\s@]+\.(?:com|in|org|net|edu|gov|co\.uk|io|info)$/i;
    if (!EMAIL_REGEX.test(email)) {
      toast.error("Invalid email address");
      return;
    }

    try {
      setLoading(true); // Start loading
      const response = await axios.post(
        // "https://yelospace.com/api/authenticate/user",
        "https://yelospace.com/api/authenticate/user",
        {
          email,
          password,
        }
      );

      if (response.data.status === 401) {
        //console.log"Unauthorized User");
        toast.error("Please enter a valid email or password.");
        return; // Add this line to prevent further execution
      }

      if (response.data.status === 200) {
        const data = JSON.stringify({
          userData: response?.data?.response,
          jwt: response?.data?.response?.jwt,
          role: "user",
        });
        //console.logdata);
        localStorage.setItem("data", data);
        localStorage.setItem("role", 'user');
        navigate("/home");
      }
    } catch (error) {
      console.error("Error occurred:", error);
      toast.error("An error occurred. Please try again later.");
    } finally {
      setLoading(false); // Finish loading
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(()=>{
    if(location?.state?.signUp){
      //console.loglocation.state.signup);
      window.history.replaceState({}, '')
      toast.success('Congratulations! You have successfully Signed Up');
    }
  },[])

  return (
    <>
      {/* <Navbar /> */}
      <ToastContainer />
      <div className="login-container">
      <div className="w-100 d-flex justify-content-center">
        <div className="left-panel">
          <img src={loginImg} alt="Left Panel Image" />
        </div>
        <div className="right">
        <div className="w-100 d-flex justify-content-center">
   <Link to="/">
      <img src={logo} className="logo-img" alt="Left Panel Image" />
   </Link>
</div>

          <div className="w-100 d-flex justify-content-center">
          <h3>Login to get started</h3>
          </div>
          <form className="w-100" onSubmit={handleSubmit}>
            <div className="w-100">
              <input
                type="email"
                name="email"
                placeholder="Email *"
                value={email}
                className="form-control w-75 mx-auto p-2 bg-color"
                onChange={handleEmailChange}
              />
              {submitted && email.trim() === "" && (
                <span className="login-error">Email is required</span>
              )}
            </div>
            <div className="w-100">
              <div className="password-input-container">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Password *"
                  className="form-control w-75 mx-auto mt-3 p-2 bg-color"
                  value={password}
                  onChange={handlePasswordChange}
                />
                {/* Eye icon */}
                <span
                  className="password-toggle-btn"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? (
                    <FontAwesomeIcon icon={faEyeSlash} />
                  ) : (
                    <FontAwesomeIcon icon={faEye} />
                  )}
                </span>
              </div>

              {submitted && password.trim() === "" && (
                <span className="login-error">Password is required</span>
              )}
            </div>
            <div className="w-100 d-flex justify-content-center">
              <button
                type="submit"
                disabled={loading ? true : false}
                className="submit-btn mx-auto mt-4"
              >
                {loading ? "Processing..." : "Login"}
              </button>
            </div>
          </form>
          <div className="forgot-password" >
            <Link to="/forgot-password">Forgot password?</Link>
          </div>

          <div className="d-flex justify-content-center w-100">
            <p className="signup-link">
              New user? <Link to="/signup">Sign up</Link>
            </p>
          </div>
          <div className="d-flex justify-content-center w-100 mt-4">
            <div className="continue">
              <Link to="/" 
                className="border py-3 px-3 mt-4" 
                style={{fontWeight:'bold'}}
                onClick={()=>localStorage.setItem('role', 'Guest')}>
                Continue As Guest
              </Link>
            </div>
          </div>
        </div>
        </div>
      </div>
    </>
  );
}

export default Login;
